h = require('./helpers')

class Documents
  applyStyles: ->
    console.log 'Применяю стили Documents'
    $form = $('#aspnetForm')

#    $('body').removeClass().addClass('documents')

    if $('.documents-content').length == 0
      h.h1('Договоры и отчеты агента', 'h1-documents').appendTo $form
      [$row, $wrapper] = h.rowN(true, 'documents-content')
      $form.append $row

      $div = $ '<div/>'
      $wrapper.append $div
      $wrapper.append $('#ctl00_generalContent_TabContainer1_TabPanel3_partnerFilesList_ctl00')

      $.getJSON '//www.tourtrans.ru/pages/master/documents.html?json=1&jsoncallback=?', (data) =>
        $div.append(data.fulltext)

module.exports = new Documents
